<div class="modal-header">
  <h4 class="modal-title" id="modal-basic-title">{{'Circuito' | translate}} - {{Circuito.Titulo}}</h4>
  <button type="button" class="close" [disabled]="carregando" aria-label="Close" (click)="fecharModal()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>

<div class="modal-bidy" style="min-height: 250px;">

  <div class="overlay" *ngIf="carregando">
    <app-view-loading></app-view-loading>
  </div>

  <mat-stepper [disableRipple]="true" #stepper>
    <mat-step [stepControl]="detalhesGroup" [editable]="stepVisitado[0]">
      <ng-template matStepLabel>Detalhes</ng-template>

      <ul ngbNav #nav="ngbNav" [(activeId)]="activeTab" class="nav-pills mb-3 mt-md-2 mt-2 mx-2 mx-md-2">
        <li [ngbNavItem]="'daybyday'">
          <a ngbNavLink>Day By Day</a>
          <ng-template ngbNavContent>
            <div class="p-3">
              <div *ngIf="circuitoDetalhes?.DaybyDay?.length > 0; else semDaybyDay">
                <div class="accordion" id="dayByDayAccordion">
                  <div class="accordion-item" *ngFor="let dayByDay of circuitoDetalhes.DaybyDay; let i = index">
                    <h2 class="accordion-header" [id]="'heading' + i">
                      <button class="accordion-button" [class.collapsed]="i !== 0" type="button"
                        data-bs-toggle="collapse" [attr.data-bs-target]="'#collapse' + i" [attr.aria-expanded]="i === 0"
                        [attr.aria-controls]="'collapse' + i">
                        <i class="fa fa-bars me-2"></i>
                        {{ dayByDay.Titulo }} - {{ dayByDay.Dia }}
                      </button>
                    </h2>
                    <div [id]="'collapse' + i" class="accordion-collapse collapse" [class.show]="i === 0"
                      [attr.aria-labelledby]="'heading' + i" data-bs-parent="#dayByDayAccordion">
                      <div class="accordion-body text-center">
                        <p [innerHTML]="dayByDay.Descricao"></p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <ng-template #semDaybyDay>
                <p class="text-muted text-center">Nenhum item do Day By Day disponível.</p>
              </ng-template>
            </div>
          </ng-template>
        </li>

        <li *ngIf="Observacoes?.length > 0" [ngbNavItem]="'observacoes'">
          <a ngbNavLink>Observações</a>
          <ng-template ngbNavContent>
            <div class="p-3">
              <div *ngFor="let observacao of Observacoes">
                <p [innerHTML]="observacao"></p>
              </div>
            </div>
          </ng-template>
        </li>

        <li *ngIf="Circuito.Fornecedor !== 'SRL'" [ngbNavItem]="'servicos-inclusos'">
          <a ngbNavLink>Serviços Inclusos</a>
          <ng-template ngbNavContent>
            <div class="p-3">
              <div *ngFor="let servico of ServicosInclusos">
                <p [innerHTML]="servico"></p>
              </div>
            </div>
          </ng-template>
        </li>

        <li *ngIf="Circuito.Fornecedor !== 'SRL'" [ngbNavItem]="'hoteis-previstos'">
          <a ngbNavLink>Hotéis Previstos</a>
          <ng-template ngbNavContent>
            <div class="p-3">
              <div *ngFor="let hotelPrevisto of circuitoDetalhes?.HoteisPrevistos; let i = index" class="row mb-3">
                <div class="col-md-6 d-flex" style="font-size: 18px !important;">
                  <p class="text-muted"><strong class="text-muted">{{"Hotel" | translate}}: </strong>
                    {{hotelPrevisto?.Nome}}</p>
                </div>

                <div *ngIf="Circuito.Fornecedor == 'ST' else europamundoEstrelas" class="col-md-2 text-center">
                  <strong>{{"Categoria" | translate}}: </strong>{{hotelPrevisto?.Categoria}}
                </div>

                <ng-template #europamundoEstrelas class="col-md-2 text-center">
                  <app-estrela [estrela]="hotelPrevisto.Categoria"></app-estrela>
                </ng-template>

                <div class="col-md-2 text-right"><strong>{{"Cidade" | translate}}: </strong>{{hotelPrevisto?.Cidade}}
                </div>
                <div class="col-md-2 text-right"><strong>{{"País" | translate}}: </strong>{{hotelPrevisto?.Pais}}</div>

              </div>
            </div>
          </ng-template>
        </li>

        <li *ngIf="Circuito.Fornecedor != 'ST'" [ngbNavItem]="'imagens'">
          <a ngbNavLink>Imagens</a>
          <ng-template ngbNavContent>
            <ngb-carousel *ngIf="Imagens">
              <ng-template ngbSlide *ngFor="let img of Imagens; let i = index">
                <img [src]="Img" alt="Imagem {{i+1}}" style="height: 82vh; width: 100% !important; object-fit: cover; border-radius: 10px;
                    border: 2px solid gray;" />
              </ng-template>
            </ngb-carousel>
          </ng-template>
        </li>
      </ul>
      <div [ngbNavOutlet]="nav"></div>

      <div class="row col-md-12 text-center mt-3 mt-md-2" *ngIf="circuitoDetalhes?.Disponibilidades?.length == 0">
        <h4>{{"Este circuito não possui disponibilidades" | translate}}</h4>
      </div>

      <div class="d-flex justify-content-center mt-md-2 mt-3 mb-3 mb-md-3" style="border: 0">
        <button class="btn btn-success" matStepperNext
          [disabled]="circuitoDetalhes?.Disponibilidades?.length == 0">{{'Buscar Disponibilidade' | translate}}</button>
      </div>

    </mat-step>

    <mat-step [stepControl]="tarifacaoGroup" [editable]="stepVisitado[1]">
      <ng-template matStepLabel>Tarifação</ng-template>
      <div class="row">

        <div NgbAccordion>
          <div NgbAccordionItem>
            <div NgbAccordionHeader>
              <div class="text-center mb-5">
                <h4 class="text-muted">{{ "Escolha uma data de partida" | translate }}</h4>
              </div>
            </div>

            <div NgbAccordionBody>
              <ng-container *ngFor="let Mes of Meses.Mes; let first = first; let last = last; let i = index;">
                <ng-container *ngIf="indexAtual == i">
                  <div class="row" style="padding: 0px 2rem">
                    <div class="col-md-1 text-left">
                      <button class="btn btn-success align-self-center" (click)="indexAtual = indexAtual - 1"
                        [disabled]="first">
                        <i class="fa fa-arrow-left" aria-hidden="true"></i>
                      </button>
                    </div>
                    <div class="col-md-10 text-center">
                      <h4 align-self-center>{{Mes.Nome}} - {{Mes.Ano}}</h4>
                    </div>
                    <div class="col-md-1" style="text-align: right">
                      <button class="btn btn-success align-self-center" (click)="indexAtual = indexAtual + 1"
                        [disabled]="last">
                        <i class="fa fa-arrow-right" aria-hidden="true"></i>
                      </button>
                    </div>
                  </div>
                  <div class="row p-3" [ngClass]="Mes.Disponibilidades.length >= 6 ? 'overflow-card' : ''">
                    <div class="col-md-6" *ngFor="let disponibilidade of Mes.Disponibilidades">
                      <div
                        class="d-flex flex-row m-1 pt-md-3 pt-3 pb-md-3 pb-3 px-md-3 px-2 pe-md-3 pe-2 card justify-content-around">
                        <div class="d-flex justify-content-center flex-column me-md-4 me-3">
                          <h4 class="align-self-center col-md mb-0">{{disponibilidade.Data | date: 'dd/MM/yyyy' }}</h4>
                          <div class="align-self-center col-md">
                            <strong *ngIf="Circuito.Fornecedor == 'EM'">{{disponibilidade.CategoriaCodigo}}
                              ({{disponibilidade.QuantidadeDisponivel}})</strong>
                            <strong *ngIf="Circuito.Fornecedor != 'EM'">{{disponibilidade.CategoriaNome}}
                              ({{disponibilidade.StatusDiponibilidade}})</strong>
                          </div>
                        </div>
                        <div style="align-self: center col-md">
                          <div class="d-flex flex-column" syle="gap: 2px">
                            <ng-container *ngIf="circuitoDetalhes?.ValidaApartamentos?.PermiteSingle">
                              <span><strong>Single: </strong>
                                {{disponibilidade?.MoedaListagem?.Sigla}}
                                {{disponibilidade?.PrecoSingle?.toFixed(2)}}
                              </span>
                            </ng-container>
                            <span><strong>{{"Duplo" | translate }}: </strong>
                              {{disponibilidade?.MoedaListagem?.Sigla}}
                              {{disponibilidade?.PrecoDouble?.toFixed(2)}}
                            </span>
                            <ng-container *ngIf="circuitoDetalhes?.ValidaApartamentos?.PermiteShared">
                              <span><strong>{{"Compartilhado" | translate }}: </strong>
                                {{disponibilidade?.MoedaListagem?.Sigla}}
                                {{disponibilidade?.PrecoShared?.toFixed(2)}}
                              </span>
                            </ng-container>
                            <ng-container *ngIf="circuitoDetalhes?.ValidaApartamentos?.PermiteTriple">
                              <span><strong>{{"Triplo" | translate }}: </strong>
                                {{disponibilidade?.MoedaListagem?.Sigla}}
                                {{disponibilidade?.PrecoTriple?.toFixed(2)}}
                              </span>
                            </ng-container>
                            <ng-container *ngIf="circuitoDetalhes?.ValidaApartamentos?.PermiteQuadruple">
                              <span><strong>{{"Quadruplo" | translate }}: </strong>
                                {{disponibilidade?.MoedaListagem?.Sigla}}
                                {{disponibilidade?.PrecoQuadruple?.toFixed(2)}}
                              </span>
                            </ng-container>
                          </div>
                        </div>
                        <div class="col-md align-self-center text-center">
                          <button class="btn btn-success" (click)="selecionarDisponibilidade(disponibilidade)"
                            [disabled]="DisponibilidadeSelecionada == disponibilidade || disponibilidade.StatusDisponibilidade == 'FULL'">{{DisponibilidadeSelecionada
                            == disponibilidade ? "Selecionado" : "Selecionar" | translate}}</button>
                        </div>
                      </div>
                    </div>
                  </div>
                </ng-container>
              </ng-container>
            </div>

          </div>
        </div>

        <div NgbAccordion>
          <div NgbAccordionItem>
            <div NgbAccordionHeader>
              <div class="text-center mb-md-3 mb-2 mt-2 mt-md-2">
                <h4 class="text-muted">{{"Escolha uma quantidade de quartos" | translate}}</h4>
              </div>
            </div>

            <div NgbAccordionBody class="row justify-content-center mb-md-4 mb-3" style="padding: 0px 2rem; gap: 15px">

              <div class="col-md-3 row justify-content-center"
                *ngIf="circuitoDetalhes?.ValidaApartamentos?.PermiteSingle && !(adicionando && tarifarCircuitoRQ.Single == 0 && qntdMax < 1)">
                <app-custom-number-picker text="Single" [useIcon]="true"
                  (changeModel)="tarifarCircuitoRQ.Single = $event" [model]="tarifarCircuitoRQ.Single"
                  (increase)="alterarQuarto('Single', 'Adicionar')" (decrease)="alterarQuarto('Single', 'Remover')">
                </app-custom-number-picker>
              </div>

              <div class="col-md-3 row justify-content-center"
                *ngIf="circuitoDetalhes?.ValidaApartamentos?.PermiteShared && !(adicionando && tarifarCircuitoRQ.Shared == 0 && qntdMax < 1)">
                <app-custom-number-picker text="Compartilhado" [useIcon]="true"
                  (changeModel)="tarifarCircuitoRQ.Shared = $event" [model]="tarifarCircuitoRQ.Shared"
                  (increase)="alterarQuarto('Shared', 'Adicionar')" (decrease)="alterarQuarto('Shared', 'Remover')">
                </app-custom-number-picker>
              </div>

              <div class="col-md-3 row justify-content-center"
                *ngIf="!(adicionando && tarifarCircuitoRQ.Double == 0 && qntdMax <= 2)">
                <app-custom-number-picker text="Double" [useIcon]="true" [iconCount]="2"
                  (changeModel)="tarifarCircuitoRQ.Double = $event" [model]="tarifarCircuitoRQ.Double"
                  (increase)="alterarQuarto('Double', 'Adicionar')" (decrease)="alterarQuarto('Double', 'Remover')">
                </app-custom-number-picker>
              </div>

              <div class="col-md-3 row justify-content-center"
                *ngIf="circuitoDetalhes?.ValidaApartamentos?.PermiteTriple && !(adicionando && tarifarCircuitoRQ.Triple == 0 && qntdMax < 3)">
                <app-custom-number-picker text="Triple" [useIcon]="true" [iconCount]="3"
                  (changeModel)="tarifarCircuitoRQ.Triple = $event" [model]="tarifarCircuitoRQ.Triple"
                  (increase)="alterarQuarto('Triple', 'Adicionar')" (decrease)="alterarQuarto('Triple', 'Remover')">
                </app-custom-number-picker>
              </div>

              <div class="col-md-3 row justify-content-center"
                *ngIf="circuitoDetalhes?.ValidaApartamentos?.PermiteQuadruple && !(adicionando && tarifarCircuitoRQ.Quadruple == 0 && qntdMax < 4)">
                <app-custom-number-picker text="Quadruple" [useIcon]="true" [iconCount]="4"
                  (changeModel)="tarifarCircuitoRQ.Quadruple = $event" [model]="tarifarCircuitoRQ.Quadruple"
                  (increase)="alterarQuarto('Quadruple', 'Adicionar')"
                  (decrease)="alterarQuarto('Quadruple', 'Remover')">
                </app-custom-number-picker>
              </div>

            </div>
          </div>
        </div>

        <div class="card-sem-sombra col-md-12 mb-3 mt-3" *ngIf="adicionando == true">
          <ngb-alert status="success" closable *ngIf="qntdMax == 0 && DisponibilidadeSelecionada != undefined"
            class="text-center">
            <div class="d-flex justify-content-center">
              <span class="me-3">{{"Apartamentos preenchidos, agora você pode tarifar" | translate}}</span>
              <i class="fa fa-check" aria-hidden="true"></i>
            </div>
          </ngb-alert>

          <ngb-alert status="danger" closable *ngIf="qntdMax > 0 || DisponibilidadeSelecionada == undefined"
            class="text-center">
            <div class="d-flex justify-content-center w-100">
              <span class="me-3">{{"Apartamentos ainda não preenchidos, você ainda não pode tarifar" |
                translate}}</span>
              <i class="fa fa-exclamation-circle" aria-hidden="true"></i>
            </div>
            <span *ngIf="qntdMax > 0" class="w-100">
              {{"Você ainda precisa adicionar apartamentos para: "+ qntdMax + " Pessoas" | translate}}
            </span>
            <span *ngIf="DisponibilidadeSelecionada == undefined" class="w-100">
              {{"Você precisa selecionar uma disponibilidade" | translate}}
            </span>
          </ngb-alert>
        </div>

        <div NgbAccordion class="card-sem-sombra col-md-12 mb-5"
          *ngIf="(tarifarCircuitoRQ.Single > 0 || tarifarCircuitoRQ.Double > 0 || tarifarCircuitoRQ.Triple > 0 || tarifarCircuitoRQ.Shared > 0 || tarifarCircuitoRQ.Quadruple > 0) && !adicionando">
          <div NgbAccordionItem [expanded]="true">
            <div NgbAccordionBody>
              <div class="row col-md-12">
                <div class="row col-md-12 mb-3">
                  <div class="col-md-4"></div>
                  <h4 class="text-muted col-md-4 text-center">
                    {{"Dados dos passageiros" | translate}}</h4>
                </div>
                <ng-container class="row col-md-12 p-2 p-md-2 mb-3 mb-md-3 mt-2 mt-md-2"
                  *ngIf="tarifarCircuitoRQ.PaxSingle.length > 0">
                  <div class="col-md-12 text-center mb-2 mb-md-3 mt-2 mt-md-3">
                    <span class="mt-2 mt-md-2">
                      {{"Idades dos passageiros em apartamento" | translate}}
                      <strong>Single</strong>
                    </span>
                  </div>
                  <div class="col-md-2" *ngFor="let dtSingle of tarifarCircuitoRQ.PaxSingle; let i = index;">
                    <label class="label">{{'Idade' | translate}}</label>
                    <input autocomplete="off" class="form-control input-sm" placeholder="Idade do Pax"
                      [(ngModel)]="dtSingle.Idade" type="number">
                  </div>
                </ng-container>

                <ng-container class="row col-md-12 p-2 p-md-2 mb-3 mb-md-3 mt-2 mt-md-2"
                  *ngIf="tarifarCircuitoRQ.PaxDouble.length > 0">
                  <div class="col-md-12 text-center mb-2 mb-md-3 mt-2 mt-md-3">
                    <span class="mt-2 mt-md-2">
                      {{"Idades dos passageiros em apartamento" | translate}}
                      <strong>{{"Duplo" | translate }}</strong>
                    </span>
                  </div>
                  <div class="col-md-2" *ngFor="let dtDouble of tarifarCircuitoRQ.PaxDouble; let i = index;">
                    <label class="label">{{'Idade' | translate}}</label>
                    <input autocomplete="off" class="form-control input-sm" type="number"
                      [placeholder]="'Idade do Pax' | translate" [(ngModel)]="dtDouble.Idade">
                  </div>
                </ng-container>

                <ng-container class="row col-md-12 p-2 p-md-2 mb-3 mb-md-3 mt-2 mt-md-2"
                  *ngIf="tarifarCircuitoRQ.PaxShared.length > 0">
                  <div class="col-md-12 text-center mb-2 mb-md-3 mt-2 mt-md-3">
                    <span class="mt-2 mt-md-2">
                      {{"Idades dos passageiros em apartamento" | translate}}
                      <strong>{{"Compartilhado" | translate}}</strong>
                    </span>
                  </div>
                  <div class="col-md-3" *ngFor="let dtShared of tarifarCircuitoRQ.PaxShared; let i = index;">
                    <label class="label">{{'Idade' | translate}}</label>
                    <input autocomplete="off" class="form-control input-sm" type="number"
                      [placeholder]="'Idade do Pax' | translate" [(ngModel)]="dtShared.Idade">
                  </div>
                </ng-container>

                <ng-container class="row col-md-12 p-2 p-md-2 mb-3 mb-md-3 mt-2 mt-md-2"
                  *ngIf="tarifarCircuitoRQ.PaxTriple.length > 0">
                  <div class="col-md-12 text-center mb-2 mb-md-3 mt-2 mt-md-3">
                    <span class="mt-2 mt-md-2">{{"Idades dos passageiros em apartamento" | translate }}
                      <strong>{{"Triplo" | translate }}</strong></span>
                  </div>
                  <div class="col-md-3" *ngFor="let dtTriple of tarifarCircuitoRQ.PaxTriple; let i = index;">
                    <label class="label">{{'Idade' | translate}}</label>
                    <input autocomplete="off" class="form-control input-sm" type="number"
                      [placeholder]="'Idade do Pax' | translate" [(ngModel)]="dtTriple.Idade">
                  </div>
                </ng-container>

                <ng-container class="row col-md-12 p-2 p-md-2 mb-3 mb-md-3 mt-2 mt-md-2"
                  *ngIf="tarifarCircuitoRQ.PaxQuadruple.length > 0">
                  <div class="col-md-12 text-center mb-2 mb-md-3 mt-2 mt-md-3">
                    <span class="mt-2 mt-md-2">
                      {{"Idades dos passageiros em apartamento" | translate }}
                      <strong>{{"Quádruplo"| translate}}</strong>
                    </span>
                  </div>
                  <div class="col-md-3" *ngFor="let dtQuadruple of tarifarCircuitoRQ.PaxQuadruple; let i = index;">
                    <label class="label">{{'Idade' | translate}}</label>
                    <input autocomplete="off" class="form-control input-sm" type="number"
                      [placeholder]="'Idade do Pax' | translate" [(ngModel)]="dtQuadruple.Idade">
                  </div>
                </ng-container>

              </div>
            </div>
          </div>
        </div>
        <div class="col-md-12 d-flex justify-content-center">
          <span *ngIf="Circuito?.Fornecedor == 'SAT'" class="mt-3 red">{{"Máximo de 4 quartos permitidos por tarifação."
            | translate }}</span>
        </div>
        <div class="col-md-12 d-flex justify-content-center">
          <button class="btn btn-success me-5" matStepperPrevious>{{'Detalhes' | translate}}</button>
          <button class="btn btn-success" [disabled]="!temTarifa() || DisponibilidadeSelecionada == undefined"
            (click)="tarifarCircuito()">{{'Tarifar Circuito' | translate}}</button>
        </div>
      </div>

    </mat-step>

    <mat-step [stepControl]="revisaoGroup" [editable]="stepVisitado[2]">
      <ng-template matStepLabel>Revisão</ng-template>

      <div class="card">
        <div class="card-body row" *ngIf="circuitoTarifado">
          <div class="col-12 row d-flex justify-content-between mb-4 mb-md-4 mt-4 mt-md-4">
            <div class="col-md-3 d-flex justify-content-center align-self-center">
              <img [src]="circuitoTarifado?.ImagemPrincipal" style="width: 300px; max-width: 300px; height: 150px; max-height: 150px; object-fit: cover;
                    object-position: center; border: 1px solid gray; border-radius: 5px;" />
            </div>
            <div class="row col-md-9">
              <div class="row col-md-12">
                <h4 class="fonte-cabecalho-card col-md-7"> {{circuitoTarifado?.Titulo}}</h4>
                <div class="col-md-5 text-center">
                  <span>
                    <strong>{{"Duração" | translate}}:</strong>
                    {{circuitoTarifado?.Duracao}} {{" Dias" | translate}}
                  </span><br>
                </div>
              </div>
              <div class="row col-md-12">
                <div class="col-md align-self-center">
                  <span>
                    <strong>{{"Inicio em" | translate}}:</strong>
                    {{transformString(circuitoTarifado?.CidadeInicio)}}
                  </span><br>
                  <span>
                    <strong>{{"Países Percorridos" | translate}}:</strong>
                    {{transformString(circuitoTarifado?.PaisesPercorridos)}}
                  </span><br>
                  <span>
                    <strong>{{"Data" | translate}}:</strong>
                    {{DisponibilidadeSelecionada?.Data | date: 'dd/MM/yyyy'}}
                    <!-- {{transformString(DisponibilidadeSelecionada?.Data | date: 'dd/MM/yyyy')}} -->
                  </span>
                </div>
                <div class="col-md align-self-center" *ngIf="circuitoTarifado?.Fornecedor != 'ST'">
                  <span>
                    <strong>{{"Final em" | translate}}:</strong>
                    {{transformString(circuitoTarifado?.CidadeFim)}}
                  </span><br>
                  <span>
                    <strong>{{"Cidades Percorridas" | translate}}:</strong>
                    {{transformString(circuitoTarifado?.CidadesPercorridas)}}
                  </span>
                </div>
              </div>
            </div>
          </div>

          <div class="col-md-12 row" *ngIf="circuitoTarifado?.Fornecedor === 'SRL'">
            <div class="col-12">
              <h3 class="mx-3 mx-md-3 fonte-cabecalho-card">{{"Escolha seu Quarto" | translate}}</h3>
            </div>
            <div [(ngModel)]="quartoSelecionado" ngbRadioGroup name="quartosTarifados"
              class="d-flex flex-column align-items-start">
              <div *ngFor="let quarto of circuitoTarifado.SelecaoQuartos; trackBy: trackByCodigo" class="form-check">
                <input type="radio" class="form-check-input" [value]="quarto.Codigo" name="quartosTarifados"
                  (change)="selecionouQuarto(quarto.Codigo)" />
                <label class="form-check-label">
                  {{quarto.Descricao}} - {{quarto.CategoriaDescricao}} -
                  Valor total do quarto: {{quarto.MoedaSigla}} {{quarto.ValorQuarto.toFixed(2)}}
                </label>
              </div>
            </div>
          </div>

          <div class="col-md-12 row align-self-center">
            <div class="col-md-10 d-flex justify-content-center align-self-center mb-2" style="gap: 25px">
              <span *ngIf="circuitoTarifado?.Single > 0"><strong>{{'Apt Single' | translate}}:
                </strong>{{circuitoTarifado?.Single}}</span>
              <span *ngIf="circuitoTarifado?.Double > 0"><strong>{{'Apt Double' | translate}}:
                </strong>{{circuitoTarifado?.Double}}</span>
              <span *ngIf="circuitoTarifado?.Shared > 0"><strong>{{'Apt Shared' | translate}}:
                </strong>{{circuitoTarifado?.Shared}}</span>
              <span *ngIf="circuitoTarifado?.Triple > 0"><strong>{{'Apt Triple' | translate}}:
                </strong>{{circuitoTarifado?.Triple}}</span>
              <span *ngIf="circuitoTarifado?.Quadruple > 0"><strong>{{'Apt Quadruple' | translate}}:
                </strong>{{circuitoTarifado?.Quadruple}}</span>
              <span *ngIf="circuitoTarifado?.Fornecedor != 'SAT'"><strong>{{(["ST",
                  "SRL"].includes(circuitoTarifado?.Fornecedor) ? "Categoria" : "Temporada") | translate}}:
                </strong>{{["ST", "SRL"].includes(circuitoTarifado?.Fornecedor) ? circuitoTarifado?.CategoriaNome :
                circuitoTarifado?.CategoriaCodigo}}</span>
            </div>

            <div class="col-md d-flex justify-content-end mb-2">
              <div class="d-flex flex-column" style="text-align: right !important;">
                <strong>Valor Total:</strong>
                <h5>{{circuitoTarifado?.MoedaListagem?.Sigla}} {{circuitoTarifado?.ValorListagem.toFixed(2)}}</h5>
              </div>
            </div>

          </div>
        </div>

        <div class="card-footer col-md-12 d-flex justify-content-center modal-footer">
          <button class="btn btn-warning me-2 me-md-2" matStepperPrevious>{{"Retarifar" | translate}}</button>
          <button class="btn btn-success" [disabled]="circuitoTarifado?.Fornecedor === 'SRL' && bloqueiaSeguir"
            (click)="salvarOrcamento()">{{"Gerar Reserva" | translate}}</button>
        </div>
      </div>
    </mat-step>

  </mat-stepper>

</div>
<div class="modal-footer" style="border-top: 0px !important">
  <div *ngIf="mensagemErro?.length > 0" class="alert alert-danger alert-dismissible fade show col col-md-12"
    role="alert">
    <strong>{{mensagemErro | translate}}</strong><br>
    <button type="button" class="close" data-dismiss="alert" aria-label="Close" (click)="mensagemErro = ''">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
</div>